import { Button } from 'src/components/atoms';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const EventDetailsContainer = styled.div<{
  first?: boolean;
  last?: boolean;
}>`
  margin: 0;
  padding: 20px;
  border-top: ${(props) =>
    props.first
      ? 'none'
      : `solid 1px ${props.theme.isVaultVariant ? props.theme.newPalette.neutral.N300 : props.theme.atlas.semantic.color.ui.divider.default}`};
  border-bottom-left-radius: ${(props) => (props.last ? '6px' : '0px')};
  border-bottom-right-radius: ${(props) => (props.last ? '6px' : '0px')};
  &:hover {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N100
        : props.theme.atlas.semantic.color.surface.subtle};
  }
`;

export const EventDetailsTitle = styled.h4`
  margin: 0 0 20px 0;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const EventDetailsSubtitle = styled.h5`
  margin: 0 0 12px 0;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleSubheading
      : textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const EventDetailsEvidenceList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 13px;
`;

export const EventDetailsIconContainer = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
`;

export const EventDetailsDescription = styled.div<{
  margin?: boolean;
  fullWidth?: boolean;
}>`
  margin: ${(props) => (props.margin ? '0 0 20px 0' : '0')};
  width: ${(props) => (props.fullWidth ? '100%' : '50%')};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  white-space: pre-line;
`;

export const NamedOffendersText = styled.p`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  margin: 0;
`;

export const EventDetailsTitleAndButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EventDetailsButton = styled(Button)`
  column-gap: 4px;
`;

export const EventDetailsGrid = styled.div<{ checkbox?: boolean }>`
  margin-top: 20px;
  display: grid;
  grid-template-columns: ${(props) =>
    props.checkbox ? '1fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr' : 'repeat(7, 1fr)'};
  row-gap: 13px;
  column-gap: 20px;
`;

export const EventDetailsGridTitle = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleSubheading
      : textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const EventDetailsTranslateContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const NamedOffenderHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const EventHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TranscriptionDisclaimer = styled.p`
  margin: 0;
  font-style: italic;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;
